export default "__VITE_ASSET__BTU8cYfK__"